'use es6';

import { Networks } from 'AdsUI/lib/Constants';
const NETWORKS_KEY_MAP = {
  [Networks.ADWORDS]: 'adWordsAccountIds',
  [Networks.FACEBOOK]: 'facebookAccountIds',
  [Networks.LINKEDIN]: 'linkedInAccountIds'
};
export default (adAccounts => adAccounts.reduce((byNetwork, adAccount) => {
  byNetwork[NETWORKS_KEY_MAP[adAccount.network]].push(adAccount.accountId);
  return byNetwork;
}, Object.values(NETWORKS_KEY_MAP).reduce((keys, key) => {
  keys[key] = [];
  return keys;
}, {})));